import { UniqueIdService } from './unique-id.service';
import { Assessment } from "../models/assessment";
import { ScaleResult } from "../models/scale-result";
import { QuestionType } from "../models/question-type";
import { AssessmentResult } from "../models/assessment-result";
// TODO: stephen would it make sense to rename this ScaleResultNode to something else as it can be confused with ScaleResult
var ScaleResultNode = /** @class */ (function () {
    function ScaleResultNode(data) {
        this._children = [];
        this._data = data;
        this._calculated = false;
        if (data.scale.type == "CriteriaThreshold") {
            this._calculatorStategy = new ScaleCalculatorCriteriaThresholdStrategy(data.scale);
        }
        else if (data.scale.type == "Mean") {
            this._calculatorStategy = new ScaleCalculatorMeanStrategy();
        }
        else {
            this._calculatorStategy = new ScaleCalculatorSumStrategy();
        }
    }
    Object.defineProperty(ScaleResultNode.prototype, "children", {
        get: function () {
            return this._children;
        },
        set: function (v) {
            this._children = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultNode.prototype, "data", {
        get: function () {
            return this._data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultNode.prototype, "calculated", {
        get: function () {
            return this._calculated;
        },
        enumerable: true,
        configurable: true
    });
    ScaleResultNode.prototype.calculateQuestion = function (question) {
        this._data = this._calculatorStategy.calculate(this._data, question);
    };
    ScaleResultNode.prototype.calculateTotal = function (limit) {
        if (!limit) {
            limit = 0;
        }
        if (limit > 50) {
            throw new Error("Recursive limit reached.  Maximum child depth was greater than 50 nodes");
        }
        var score = this.data.score;
        if (!this.calculated && this.children.length) {
            this.children.forEach(function (c) { return c.calculateTotal(limit + 1); });
            this.data.score = this.children.reduce(function (prev, current) { return current.data.score + prev; }, score);
        }
        this._calculated = true;
    };
    return ScaleResultNode;
}());
var ScaleCalculatorSumStrategy = /** @class */ (function () {
    function ScaleCalculatorSumStrategy() {
    }
    ScaleCalculatorSumStrategy.prototype.calculate = function (scaleResult, question) {
        scaleResult.score += question.getComputedScore();
        return scaleResult;
    };
    return ScaleCalculatorSumStrategy;
}());
var ScaleCalculatorMeanStrategy = /** @class */ (function () {
    function ScaleCalculatorMeanStrategy() {
        this.itemCount = 0;
        this.sum = 0;
    }
    ScaleCalculatorMeanStrategy.prototype.calculate = function (scaleResult, question) {
        this.itemCount += 1;
        this.sum += question.getComputedScore();
        scaleResult.score = this.sum / this.itemCount;
        return scaleResult;
    };
    return ScaleCalculatorMeanStrategy;
}());
var ScaleCalculatorCriteriaThresholdStrategy = /** @class */ (function () {
    function ScaleCalculatorCriteriaThresholdStrategy(scale) {
        var gradingData = scale.gradingData;
        this.requiredQuestions = gradingData.requiredQuestions || 0;
        this.requiredScoreThreshold = gradingData.requiredScoreThreshold || 0;
        this.currentQuestionsMatchingThreshold = 0;
    }
    ScaleCalculatorCriteriaThresholdStrategy.prototype.calculate = function (scaleResult, question) {
        var score = question.getComputedScore();
        if (score >= this.requiredScoreThreshold) {
            this.currentQuestionsMatchingThreshold += 1;
        }
        if (this.currentQuestionsMatchingThreshold >= this.requiredQuestions) {
            scaleResult.score = 1; // we've met the diagnostic criteria
        }
        else {
            scaleResult.score = 0;
        }
        return scaleResult;
    };
    return ScaleCalculatorCriteriaThresholdStrategy;
}());
var AssessmentGraderService = /** @class */ (function () {
    function AssessmentGraderService(_uuid) {
        this._uuid = _uuid;
    }
    AssessmentGraderService.prototype.grade = function (assessment) {
        if (!assessment) {
            throw new Error("assessment is missing.  Cannot grade");
        }
        var result = new AssessmentResult();
        result.id = this._uuid.generate();
        result.assessment = Object.assign(new Assessment(), assessment);
        result.scaleResults = this.gradeScales(assessment);
        result.flaggedQuestions = this.flagQuestions(assessment);
        return result;
    };
    AssessmentGraderService.prototype.flagQuestions = function (assessment) {
        return assessment.question_sets.map(function (qs) {
            return qs.questions.map(function (q) {
                if (q.hasFlagCondition
                    && q.flaggedCondition.shouldFlagQuestion(q, qs)) {
                    // set flag here
                    q.isFlaggedForReview = true;
                    return q;
                }
                return null;
            })
                .filter(function (q) { return q != null; });
        })
            .filter(function (questions) { return questions.length; })
            .reduce(function (prev, curr) { return curr = curr.concat(prev); }, []);
    };
    AssessmentGraderService.prototype.gradeScales = function (assessment) {
        var _this = this;
        var scaleResults = assessment.scales.map(function (s) {
            var scaleResult = new ScaleResult();
            scaleResult.scale = s;
            scaleResult.range = s.ranges[0] ? s.ranges[0] : null;
            return scaleResult;
        });
        var resultsByScale = new Map();
        // create the initial loop
        scaleResults.forEach(function (sr) {
            if (!resultsByScale[sr.scale.id]) {
                resultsByScale[sr.scale.id] = new ScaleResultNode(sr);
            }
        });
        // now create the children
        scaleResults.forEach(function (sr) {
            // now we are going to populate the trees
            if (sr.scale.hasSubScales()) {
                resultsByScale[sr.scale.id].children = sr.scale.getSubScaleIds().map(function (id) { return resultsByScale[id]; });
            }
        });
        // if there are any branching or skip-logic questions we want to only grade those.
        var questionSets = assessment.getQuestionSetsForDisplay();
        questionSets.forEach(function (qs) {
            qs.questions.forEach(function (q) {
                if (_this.shouldGradeQuestion(q)) {
                    var resultNode = resultsByScale[q.assessment_scale.id];
                    _this.gradeQuestion(q, qs, resultNode);
                }
            });
        });
        // now that the scales are graded we go through and do depth first calculation
        scaleResults.forEach(function (sr) {
            var resultNode = resultsByScale[sr.scale.id];
            resultNode.calculateTotal(); // calculate out the tree of the item.
            sr.range = sr.scale.getRangeForScore(sr.score);
        });
        return scaleResults;
    };
    AssessmentGraderService.prototype.calculateScoreWithSubScores = function (resultsByScale, result, limit) {
        var _this = this;
        if (!result.scale.hasSubScales()) {
            return result.score;
        }
        if (limit >= 50) {
            throw new Error("recursive limit reached for scale calculation.  Check scales for cycles");
        }
        // TODO: stephen if we introduced a strategy pattern here as well we could deal with different kinds
        // of sub-scal summations -- thresholds, means, averages, etc.
        var score = result.score;
        var scales = result.scale.getSubScaleIds()
            .forEach(function (scaleId) {
            var subScaleResult = resultsByScale[scaleId];
            score += _this.calculateScoreWithSubScores(resultsByScale, subScaleResult, limit + 1);
        });
        return score;
    };
    AssessmentGraderService.prototype.shouldGradeQuestion = function (q) {
        if (q.skip_scoring) {
            return false;
        }
        if (q.type != QuestionType.MultipleChoice
            && q.type != QuestionType.SingleChoice) {
            return false;
        }
        return true;
    };
    AssessmentGraderService.prototype.gradeSingleChoice = function (q, qs, scaleResult) {
        var addScore = q.is_reversed ? 0 : 1;
        var score = qs.answer_start_value;
        if (q.answerForSave.isSelected) {
            // start is 0, answer is 1, reverse, answer is 0
            score += qs.answer_start_value + addScore;
        }
        // add in the multiplier... defaults to 1
        // 0 is disabled, so don't multiply.
        if (q.assessment_scale.multiplier != 0) {
            score = score * q.assessment_scale.multiplier;
        }
        q.setComputedScore(score);
        scaleResult.calculateQuestion(q);
    };
    AssessmentGraderService.prototype.gradeMultipleChoice = function (q, qs, scaleResult) {
        // we are only allowing multiple choice questions to be graded right now
        var labels = q.CustomLabels.length ? q.CustomLabels : qs.labels;
        var totalAnswers = labels.length;
        var score = labels.indexOf(q.answer);
        // if we can't find the label we have issues
        if (score < 0) {
            console.error("Scale not found for question " + q.id);
            return;
        }
        var label = labels[score];
        // if the label is something like Not Applicable
        // we want to skip over scoring that question.
        if (label.skipScoring) {
            return;
        }
        // grab the actual scale
        if (q.is_reversed) {
            // since the startValue is inclusive we must subtract one from the count
            var endValue = qs.answer_start_value + totalAnswers - 1;
            var interval = score - qs.answer_start_value;
            score = endValue - score;
        }
        else {
            score = qs.answer_start_value + score;
        }
        // add in the multiplier... defaults to 1
        // 0 is disabled, so don't multiply.
        if (q.assessment_scale.multiplier != 0) {
            score = score * q.assessment_scale.multiplier;
        }
        q.setComputedScore(score);
        scaleResult.calculateQuestion(q);
    };
    AssessmentGraderService.prototype.gradeQuestion = function (question, qs, scaleResult) {
        if (question.type == QuestionType.MultipleChoice) {
            return this.gradeMultipleChoice(question, qs, scaleResult);
        }
        else if (question.type == QuestionType.SingleChoice) {
            return this.gradeSingleChoice(question, qs, scaleResult);
        }
    };
    return AssessmentGraderService;
}());
export { AssessmentGraderService };



// WEBPACK FOOTER //
// ./src/app/shared/services/assessment-grader.service.ts.pre-build-optimizer.js